import { render, staticRenderFns } from "./OptionPage.vue?vue&type=template&id=fb644ade&scoped=true&"
import script from "./OptionPage.vue?vue&type=script&lang=ts&"
export * from "./OptionPage.vue?vue&type=script&lang=ts&"
import style0 from "./OptionPage.vue?vue&type=style&index=0&id=fb644ade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb644ade",
  null
  
)

export default component.exports